/** 发光体法则(方案 A2.3):亮核 + 光晕L1 + 光晕L2,附呼吸。全项目发光物统一走此。 */
import { Container, Sprite } from 'pixi.js';
import { TEX } from '../engine/Tex';

export class GlowBody {
  root = new Container();
  private core: Sprite;
  private l1: Sprite;
  private l2: Sprite;
  private period: number;
  private phase: number;
  private a1 = 0.35;
  private a2 = 0.12;

  constructor(color: number, sizePx: number, haloColor = color) {
    const s = sizePx / 60;
    this.core = new Sprite(TEX.core()); this.core.anchor.set(0.5); this.core.tint = color; this.core.scale.set(s);
    this.l1 = new Sprite(TEX.glow()); this.l1.anchor.set(0.5); this.l1.blendMode = 'add'; this.l1.tint = haloColor; this.l1.scale.set(s * 2.2);
    this.l2 = new Sprite(TEX.glow()); this.l2.anchor.set(0.5); this.l2.blendMode = 'add'; this.l2.tint = haloColor; this.l2.scale.set(s * 4.5);
    this.root.addChild(this.l2, this.l1, this.core);
    this.period = 3 + Math.random() * 2;
    this.phase = Math.random() * 6.28;
  }

  update(t: number, intensity = 1) {
    const b = 0.9 + 0.1 * Math.sin((t / this.period) * Math.PI * 2 + this.phase);
    this.l1.alpha = this.a1 * b * intensity;
    this.l2.alpha = this.a2 * b * intensity;
  }
  setHalo(m: number) { this.a1 = 0.35 * m; this.a2 = 0.12 * m; }
  setColor(color: number, halo = color) { this.core.tint = color; this.l1.tint = halo; this.l2.tint = halo; }
  setScale(m: number) { this.root.scale.set(m); }
}
